type Employee = {
  id: number;
  displayName: string;
  profilePhoto: string;
  designation: string;
  ownerType: string | null;
  employeeFunction: string | null;
  email: string;
  preferredName: string;
};

export const VIOLATION_STATUS = {
  CREATED: 'CREATED',
  DENIED: 'DENIED',
  APPROVED: 'APPROVED',
  PUBLISHED_TO_EMPLOYEE: 'PUBLISHED_TO_EMPLOYEE',
  ACKNOWLEDGED: 'ACKNOWLEDGED',
} as const;

export type ViolationNote = {
  id: number;
  orgId: number;
  companyId: number | null;
  raisedFor: Employee;
  raisedBy: Employee;
  type: string;
  severity: string;
  description: string;
  descriptionHtml: string;
  reportedTime: string;
  status: keyof typeof VIOLATION_STATUS;
  evaluatedBy: Employee | null;
  evaluatedAt: string | null;
  reason: string | null;
  publishedBy: Employee | null;
  publishedAt: string | null;
  acknowledgedAt: string | null;
  publishToEmployeeAllowed: boolean;
};
